export const ADD_CUSTOMER_REQUEST = "ADD_CUSTOMER_REQUEST";
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS";
export const ADD_CUSTOMER_FAILURE = "ADD_CUSTOMER_FAILURE";

export const FETCH_CUSTOMERS_REQUEST = "FETCH_CUSTOMERS_REQUEST";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILURE = "FETCH_CUSTOMERS_FAILURE";

export const FETCH_ALL_CUSTOMERS_REQUEST = "FETCH_ALL_CUSTOMERS_REQUEST";
export const FETCH_ALL_CUSTOMERS_SUCCESS = "FETCH_ALL_CUSTOMERS_SUCCESS";
export const FETCH_ALL_CUSTOMERS_FAILURE = "FETCH_ALL_CUSTOMERS_FAILURE";

export const UPDATE_CUSTOMER_REQUEST = "UPDATE_CUSTOMER_REQUEST";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILURE = "UPDATE_CUSTOMER_FAILURE";

export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAILURE = "DELETE_CUSTOMER_FAILURE";

export const FETCH_CUSTOMER_DETAILS_REQUEST = "FETCH_CUSTOMER_DETAILS_REQUEST";
export const FETCH_CUSTOMER_DETAILS_SUCCESS = "FETCH_CUSTOMER_DETAILS_SUCCESS";
export const FETCH_CUSTOMER_DETAILS_FAILURE = "FETCH_CUSTOMER_DETAILS_FAILURE";

export const RESET_CUSTOMER_STATE = "RESET_CUSTOMER_STATE";

export const CLEAR_DELETE_SUCCESS = "CLEAR_DELETE_SUCCESS";
export const SELECT_CUSTOMER = "SELECT_CUSTOMER";
export const RESET_SELECTED_CUSTOMER = "RESET_SELECTED_CUSTOMER";

export const RESEND_CUSTOMER_PASSWORD_REQUEST =
  "RESEND_CUSTOMER_PASSWORD_REQUEST";
export const RESEND_CUSTOMER_PASSWORD_SUCCESS =
  "RESEND_CUSTOMER_PASSWORD_SUCCESS";
export const RESEND_CUSTOMER_PASSWORD_FAILURE =
  "RESEND_CUSTOMER_PASSWORD_FAILURE";
export const CLEAR_RESEND_PASSWORD_STATUS = "CLEAR_RESEND_PASSWORD_STATUS";

export const CONVERT_VENDOR_TO_CUSTOMER_REQUEST =
  "CONVERT_VENDOR_TO_CUSTOMER_REQUEST";
export const CONVERT_VENDOR_TO_CUSTOMER_SUCCESS =
  "CONVERT_VENDOR_TO_CUSTOMER_SUCCESS";
export const CONVERT_VENDOR_TO_CUSTOMER_FAILURE =
  "CONVERT_VENDOR_TO_CUSTOMER_FAILURE";
export const CLEAR_CONVERT_VENDOR_TO_CUSTOMER_STATUS =
  "CLEAR_CONVERT_VENDOR_TO_CUSTOMER_STATUS";

export const CONVERT_ROLE_REQUEST = "CONVERT_ROLE_REQUEST";
export const CONVERT_ROLE_SUCCESS = "CONVERT_ROLE_SUCCESS";
export const CONVERT_ROLE_FAILURE = "CONVERT_ROLE_FAILURE";
export const CLEAR_CONVERT_ROLE_STATUS = "CLEAR_CONVERT_ROLE_STATUS";
